import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "../../services/db";
import RecipeCard from "../../components/RecipeCard";
import Modal from "../../components/Modal/Modal";
import { useForm } from "react-hook-form";

const DeleteSectionContent = ({
  sectionId,
  handleClose,
  numberOfRecipes,
  refreshData,
}) => {
  const {
    register,
    handleSubmit,
    formState: { isLoading },
    watch,
  } = useForm();

  const isDeleteAllChecked = watch("deleteAllReceipes");

  const onSubmit = async (data) => {
    const { error, data: sectionRecipeDeleteData } = await supabase()
      .from("SectionRecipe")
      .delete()
      .eq("SectionId", sectionId)
      .select();
    if (error) {
      console.error(error);
      return;
    }
    await supabase().from("Section").delete().eq("id", sectionId);

    if (sectionRecipeDeleteData?.length > 0 && data.deleteAllRecipes) {
      await supabase()
        .from("Recipe")
        .delete()
        .eq(
          "id",
          sectionRecipeDeleteData.map((item) => item.RecipeId)
        );
    }
    await refreshData();
    handleClose();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flexColoumn">
      {numberOfRecipes ? (
        <label>
          Delete all recipes in this section as well?
          <input type="checkbox" {...register("deleteAllReceipes")} />
        </label>
      ) : null}
      {isDeleteAllChecked && <div>{numberOfRecipes} will be deleted</div>}
      <div>
        <button disabled={isLoading} type="submit">
          Delete
        </button>
      </div>
    </form>
  );
};

const FoodSection = ({ sectionName, description, id }) => {
  const { boardId } = useParams();
  const [recipes, setRecipes] = useState([]);

  async function getRecipes(recipeId) {
    const { data } = await supabase()
      .from("SectionRecipe")
      .select(
        `
      Recipe:Recipe (
        id,
        name,
        author, 
        imgSrc,
        imgInDatabase
      )
    `
      )
      .eq("SectionId", recipeId);
    data && setRecipes(data);
  }

  useEffect(() => {
    getRecipes(id);
  }, [id]);

  return (
    <div>
      <div className="flex">
        <h3 className="flex1">
          {sectionName} ({recipes.length})
        </h3>
        {/* <Modal
          buttonText={"Add to Section"}
          content={(handleClose) => (
            <DeleteSectionContent
              sectionName={sectionName}
              handleClose={handleClose}
              sectionId={id}
              numberOfRecipes={recipes.length}
              refreshData={getRecipes}
            />
          )}
          title={`Delete the "${sectionName}" section?`}
        /> */}

        <Modal
          buttonContent={"Delete Section"}
          content={(handleClose) => (
            <DeleteSectionContent
              sectionName={sectionName}
              handleClose={handleClose}
              sectionId={id}
              numberOfRecipes={recipes.length}
              refreshData={getRecipes}
            />
          )}
          title={`Delete the "${sectionName}" section?`}
        />
      </div>
      {description}
      <div className="flex flexWrap gap10">
        {recipes.map(({ Recipe }) => {
          return (
            <RecipeCard key={Recipe.id} recipe={Recipe} boardId={boardId} />
          );
        })}
      </div>
    </div>
  );
};
export default FoodSection;
